module.exports = __webpack_public_path__ + "img/icon-main.18bee816.svg";